import 'motivate-framework/dist/css/motivate.css';
import Vue from 'vue';
import Dashboard from './views/dashboard/Dashboard';
import Login from './views/login/Login';
import SetPassword from './views/invitation/SetPassword';
import Index from './Index.vue';
import router from './router/index';
import store from './store';
import './registerServiceWorker';
import Apiclient from './api-wrapper/dist';
import {Card, DataTable, isAuthenticated, Modal, Portlet} from 'motivate-framework-components';
import {dateformats, numbers} from 'motivate-vue-util/dist/lib/filters';
import {filters} from 'motivate-vue-util';
import LogRocket from 'logrocket';
import axios from 'axios';

import VuePageTransition from 'vue-page-transition';
import VeeValidate, {Validator} from 'vee-validate';
import VeeValidateLocaleNL from 'vee-validate/dist/locale/nl';
import phone from 'phone';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import {sweetAlertOptions} from './utils/sweetAlertOptions';

import vSelect from 'vue-select';
import Multiselect from 'vue-multiselect';
import 'vue-select/dist/vue-select.css';
import Datepicker from 'vuejs-datepicker';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import tiptapEditor from '../src/components/forms/tiptapEditor';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import selectMultiplePools from "@/components/selectMultiplePools";

import PictureInput from 'vue-picture-input';

import FBconfig from './fb.config';
import {firestorePlugin} from 'vuefire';
import FireStoreUploader from 'firebase-storage-uploader';

import EchoPlugin from './plugins/echo'
import { tokenFromPath } from '@/utils/clientUserInvitation';
import { handleAuthError } from './utils/authErrors'
import { reportPendingPortalLogin } from '@/utils/portalLogin'
import { isValidBsn } from '@/utils/bsn'

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import TwoFactor from './views/TwoFactor';
var MD5 = require("crypto-js/md5");
import VoerroTagsInput from '@voerro/vue-tagsinput';

require('@voerro/vue-tagsinput/dist/style.css')
window._ = require('lodash');

_.forEach(filters.dateformats, (filter, key) => {
  Vue.filter(key, filter);
});

_.forEach(numbers, (filter, key) => {
  Vue.filter(key, filter);
});
_.forEach(dateformats, (filter, key) => {
  Vue.filter(key, filter);
});
Vue.component('portlet', Portlet);
Vue.component('modal', Modal);
Vue.component('card', Card);
Vue.component('v-select', vSelect);
Vue.component('multiselect', Multiselect);
Vue.component('datepicker', Datepicker);
Vue.component('DateRangePicker', DateRangePicker);
Vue.component('VueSlider', VueSlider);
Vue.component('isAuthenticated', isAuthenticated);
Vue.component('datatables', DataTable);
Vue.component('PictureInput', PictureInput);
Vue.component('tiptapEditor', tiptapEditor);
Vue.component('selectMultiplePools', selectMultiplePools);
Vue.component('tags-input', VoerroTagsInput);
Vue.use(VuePageTransition);

Vue.use(EchoPlugin, {
  store,
  options: {
    WS_AUTH:  process.env.VUE_APP_WS_AUTH,
    WS_KEY:   process.env.VUE_APP_WS_KEY,
    WS_HOST:  process.env.VUE_APP_WS_HOST,
    WS_PORT:  process.env.VUE_APP_WS_PORT
  }
})

Vue.use(VeeValidate, {
  locale: 'nl',
  dictionary: {
    VeeValidateLocaleNL
  },
  classes: true,
  classNames: {
    valid: 'valid',
    invalid: 'is-invalid'
  }
});
Validator.localize('nl', VeeValidateLocaleNL);
Validator.extend('bsn', {
  getMessage: () => 'Dit is geen geldig BSN.',
  validate: isValidBsn
});

// Same logic as the backend's phone-parsing fix (functions/firestore/smsHistory.js):
// numbers already carrying a country code must not be forced through NL
// validation, or the phone package rejects them.
Validator.extend('phone', {
  getMessage: () => 'Dit veld moet een geldig telefoonnummer zijn.',
  validate: (value) => {
    if (!value) return false;
    const trimmed = String(value).trim();
    const convertedPhone = trimmed.startsWith('+') ? phone(trimmed) : phone(trimmed, 'NL');
    return !!convertedPhone[0];
  }
});

Vue.use(VueSweetalert2, sweetAlertOptions);

window.moment = require('moment');
require('./filters/filters');
require('./plugins/toaster');

const invitationToken = tokenFromPath(window.location.pathname);

if(invitationToken) {

  new Vue({
    store: store,
    render: h => h(SetPassword, {props: {token: invitationToken}})
  }).$mount('#app');

} else if(checkIfShouldRenderDashboard()) {

  Vue.prototype.$CLOUD_API = process.env.VUE_APP_CLOUD_API;
  var urlParams = getParameters(window.location.hash.substr(1));

  if(urlParams.hash) {
     Vue.prototype.$HASH = token = urlParams.hash.substring(0,20);
  }
  firebase.initializeApp(FBconfig);
  firebase.auth().signInAnonymously().then(() => {
  });
  Vue.prototype.$FB = firebase.firestore();
  Vue.use(firestorePlugin);
  new Vue({
    // store: store,
    render: h => h(Dashboard)
  }).$mount('#app');


} else {
  
  var token = window.localStorage.getItem('firebaseToken');
  
  if(!token) {
    firebase.initializeApp(FBconfig);
    Vue.prototype.$FB = firebase.firestore();
    Vue.use(firestorePlugin);
    new Vue({
      router: router,
      store: store,
      render: h => h(Login)
    }).$mount('#app');
  } else {

  var dataApiUrl = process.env.VUE_APP_DATA_API;
  var acApi = process.env.VUE_APP_AC_API;
  const DATA_API = axios.create({
    baseURL: dataApiUrl,
    timeout: 5000,
    headers: {
      Authorization: 'Bearer ' + token
    }
  });
  window.DATA_API = DATA_API;

  var options = {
    REDIRECT_URI: process.env.VUE_APP_REDIRECT_URI,
    CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    baseURL: acApi,
    version: 'v1',
    token: token,
    tokenHourApp: token,
    store: store,
    CLOUD_API: process.env.VUE_APP_CLOUD_API,
    HOUR_APP_BACKEND: process.env.VUE_APP_HOUR_APP_BACKEND
  };
  var APICLIENT = Apiclient(options);
  
  Vue.prototype.$ApiClient = APICLIENT;
  Vue.prototype.$CLOUD_API = process.env.VUE_APP_CLOUD_API;
  store.commit('setOauthToken', token);
  Vue.prototype.$FB_ID_TOKEN = token;

  axios.get(process.env.VUE_APP_CLOUD_API + '/authentication/2fa', {
    headers: { Authorization: 'Bearer ' + Vue.prototype.$ApiClient.token }
  }).then(response => {
    if(response.data.error) {
      ['twoFactorCode', 'firebaseToken', 'vuex', 'm-oauth-token'].forEach(key => window.localStorage.removeItem(key));
      window.indexedDB.deleteDatabase('firebaseLocalStorageDb');
      window.location = window.location.origin;
      return;
    }
    if(response.data.required) {
      new Vue({
        router: router,
        store: store,
        render: h => h(TwoFactor)
      }).$mount('#app');
      return;
    }
    bootApp();
  }).catch((err) => {
    handleAuthError(err, 'Er ging iets mis bij het controleren van tweestapsverificatie. Probeer het opnieuw.')
  });

  function bootApp() {
  store.dispatch('users/getMyProfile', {ApiClient: Vue.prototype.$ApiClient}).then((result) => {

    if (result instanceof Error) {
      handleAuthError(result, 'Er ging iets mis bij het laden van je profiel. Probeer het opnieuw.')
      return
    }

    if (!result || !result.customToken) {
      Vue.prototype.$ApiClient.logout()
      return
    }

    if(!inIframe()) {
      //initLogRocket(result.user);
    }

    /* token = result.customToken;
    var options = {
      REDIRECT_URI: process.env.VUE_APP_REDIRECT_URI,
      CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
      baseURL: acApi,
      version: 'v1',
      token: token,
      store: store,
      CLOUD_API: process.env.VUE_APP_CLOUD_API,
    };

    APICLIENT = Apiclient(options);
    Vue.prototype.$ApiClient = APICLIENT;
    console.log(Vue.prototype.$ApiClient)
    store.commit('setOauthToken', token);
    Vue.prototype.$FB_ID_TOKEN = token; */

    firebase.initializeApp(FBconfig);
    firebase.auth().signInWithCustomToken(result.customToken).then(() => {
      /* WORKFIX SPECIFIC
      //     THIS IS NOT USED THE SAME WAY IN OTHER PROJECTS
      */
      
      var preBootToken = token;
      firebase.auth().currentUser.getIdToken(true)
          .then(function (idToken) {
            var oldHash = MD5(preBootToken).toString();
            var newHash = MD5(idToken).toString();
            if (oldHash !== newHash) {
              firebase.firestore().collection('TwoFactorCodes')
                  .where('accessToken', '==', oldHash)
                  .get()
                  .then(function(res) {
                    // res.docs.forEach(function(doc) { doc.ref.update({ accessToken: newHash }); });
                  });
            }
            const token = idToken;
            window.localStorage.setItem('firebaseToken', token);
            var options = {
              REDIRECT_URI: process.env.VUE_APP_REDIRECT_URI,
              CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
              baseURL: acApi,
              version: 'v1',
              token: token,
              store: store,
              CLOUD_API: process.env.VUE_APP_CLOUD_API,
              HOUR_APP_BACKEND: process.env.VUE_APP_HOUR_APP_BACKEND,
            };

            APICLIENT = Apiclient(options);
            Vue.prototype.$ApiClient = APICLIENT;
            store.commit('setOauthToken', token);
            Vue.prototype.$FB_ID_TOKEN = token;

            reportPendingPortalLogin(store, APICLIENT);
          }).catch(function (error) {
          handleAuthError(error, 'Er ging iets mis bij het ophalen van je sessie. Probeer het opnieuw.')
          });
        firebase.auth().onAuthStateChanged(function (currentUser) {

          Vue.prototype.$USER = currentUser
          // currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          //     console.log(9999, idToken)
          //     console.log(localStorage.getItem('firebaseToken'))
          //     window.localStorage.setItem('firebaseToken', idToken);
          //   })
          // setInterval(()=>{
          //   console.log(1)
          // },10000)
        });
      Vue.prototype.$FB = firebase.firestore();
      Vue.use(firestorePlugin);
      renderVue();
    }).catch(function (error) {
        handleAuthError(error, 'Er ging iets mis bij het inloggen. Probeer het opnieuw.')
      var errorCode = error.code;
      var errorMessage = error.message;
    });

  }).catch(function (error) {
    var errorCode = error.code;
    var errorMessage = error.message;
  });
  } // end bootApp

  } // end else (token exists)

}


function renderVue() {
  // firebase.firestore().settings({
  //   host: 'localhost:8002',
  //   ssl: false,
  //   cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
  // });
  firebase.firestore().enablePersistence()
      .catch(function (err) {
        if(err.code == 'failed-precondition') {

          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
        } else if(err.code == 'unimplemented') {
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
        }
      });
  Vue.prototype.$FB_STORAGE = firebase.storage();
  Vue.prototype.$FB_UPLOADER = new FireStoreUploader(firebase.storage());

  window.FB_STORAGE = firebase.storage();

  // store.dispatch('')
  new Vue({
    router: router,
    store: store,
    render: h => h(Index)
  }).$mount('#app');
}


function initLogRocket(userData) {
  LogRocket.init(process.env.VUE_APP_LOG_ROCKET_ID);

  LogRocket.identify(userData.id, {
    name: userData.name,
    email: userData.email,

    // Add your own custom user variables here, ie:
    companyID: userData.company.id,
    company: userData.company.name
  });
}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

function getParameters(url) {
  //Params obj
  var params = {};
  //To lowercase
  // url = url.toLowerCase();
  //To array
  url = url.split('&');

  //Iterate over url parameters array
  var length = url.length;
  for (var i = 0; i < length; i++) {
    //Create prop
    var prop = url[i].slice(0, url[i].search('='));
    //Create Val
    var value = url[i].slice(url[i].search('=')).replace('=', '');
    //Params New Attr
    params[prop] = value;
  }

  return params;
}


function checkIfShouldRenderDashboard() {
  let url = window.location.pathname;
  let hash = getParameters(window.location.hash.substr(1)).hash;

  if(url === '/dashboard' && hash.includes(process.env.VUE_APP_DASHBOARD_HASH)) {
    return true;
  } else {
    return false;
  }

}


